import { useReducedMotion } from './useReducedMotion.js';

// Optional · contextual loader for SDLC PDF token request.
// Source: references/loaders-organic.html — variant #19 ("three blobs
// merging into one"). Uses the shared #ldr-goo filter from <GooDefs />.
export default function OrganicGoo({ label = 'Preparing…' }) {
  const reduced = useReducedMotion();
  return (
    <div className="ldr-center" role="status" aria-live="polite">
      <svg
        width="120"
        height="90"
        viewBox="0 0 160 120"
        filter={reduced ? undefined : 'url(#ldr-goo)'}
      >
        <circle cy="60" r="16" fill="var(--ink)" cx={reduced ? 50 : undefined}>
          {!reduced && (
            <animate attributeName="cx" values="30;80;30" dur="2.6s" repeatCount="indefinite" />
          )}
        </circle>
        <circle cy="60" cx="80" r="16" fill="var(--ink)" />
        <circle cy="60" r="16" fill="var(--ink)" cx={reduced ? 110 : undefined}>
          {!reduced && (
            <animate attributeName="cx" values="130;80;130" dur="2.6s" repeatCount="indefinite" />
          )}
        </circle>
      </svg>
      <span className="ldr-live-label">{label}</span>
    </div>
  );
}
